import { CellContext } from '@tanstack/react-table'

import { Switch } from 'components/Switch'
import { useDataForEnabledSwitch } from 'features/globalSetup/forms/Prebid/Modules/VendorSpecificForm'
import { WorkspacePrebidModuleSlice } from 'features/globalSetup/pages/Prebid/Modules/hooks/useGetWorkspacePrebidModules'
import { useUpdateWorkspacePrebidModuleEnabled } from 'features/globalSetup/pages/Prebid/Modules/hooks/useUpdateWorkspacePrebidModuleEnabled'

export const EnabledCell = ({
  getValue,
  row: {
    original: {
      id,
      prebidModule: { account: accountType, name: prebidModuleName },
      status,
    },
  },
}: CellContext<WorkspacePrebidModuleSlice, unknown>) => {
  const { checked, update } = useUpdateWorkspacePrebidModuleEnabled({
    id,
    initialChecked: Boolean(getValue()),
    prebidModuleName,
  })

  const { disabled, tooltip } = useDataForEnabledSwitch({ accountType, status })

  return (
    <Switch
      checked={checked}
      disabled={disabled}
      name={`workspace-prebid-vendor-specific-enabled-${id}`}
      onChange={update}
      tooltip={tooltip}
      tooltipMode='wrap'
    />
  )
}
